import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NannyService from "services/NannyService";

export const fetchBabysitters = createAsyncThunk(
  "babysitters/fetch",
  async (_,{rejectWithValue}) => {
    try {
      const response = await NannyService.getNannies();

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data.data.message || "Erreur");
    }
    
  }
);

export const fetchOneBabysitter = createAsyncThunk(
  "babysitter/fetch",
  async (id,{rejectWithValue}) => {
    try {
      const response = await NannyService.getOneNanny(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data.data.message || "Erreur");
    }
    
  }
);

// export const fetchNannyReport = createAsyncThunk(
//   "babysitter/fetchNannyReport",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await NannyService.getNannyRepport(id);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response.data.message || "Erreur");
//     }
//   }
// );

export const addBabysitter = createAsyncThunk(
  "nannies/addBabysitter",
  async (data, { rejectWithValue }) => {
    const { file, picFile, ...nannyData } = data;

    try {
      const response = await NannyService.addNanny(nannyData);
      const id = response.data.id;
      
      const promises = [];

      if (file) {
        const form1 = new FormData();
        form1.append("file", file.file);
        promises.push(NannyService.addNannyCv(form1, id));
      }

      if (picFile) {
        const form2 = new FormData();
        form2.append("picFile", picFile.file);
        promises.push(NannyService.addNannyPhoto(form2, id));
      }

      await Promise.all(promises);
    } catch (err) {
      console.log(err.response?.data?.data.message);
      return rejectWithValue(err.response?.data?.data.message || "Erreur");
    }
  }
);


export const updateBabysitter = createAsyncThunk(
  "babysitters/update",
  async ({id , data}, { rejectWithValue }) => {
    const { file, picFile, ...nannyData } = data;
    try {
      const response = await NannyService.UpdateNanny(id, nannyData);
      const idNanny = response.data.id;
     
      
      const promises = [];

      if (file) {
        const form1 = new FormData();
        form1.append("file", file.file);
        promises.push(NannyService.addNannyCv(form1, id));
      }

      if (picFile) {
        const form2 = new FormData();
        form2.append("picFile", picFile.file);
        promises.push(NannyService.addNannyPhoto(form2, id));
      }

      await Promise.all(promises);

    } catch (err) {
      return rejectWithValue(err.response?.data?.data.message || "Erreur");
    }
  }
);

export const deleteBabysitter = createAsyncThunk(
  "babysitters/delete",
  async (id, { rejectWithValue }) => {
    try {
      await NannyService.deleteNanny(id);
      return id;
    } catch (err) {
  
      return rejectWithValue(err.response?.data?.data.message || "Erreur");
    }
  }
);
export const fetchEvaluations = createAsyncThunk(
  "babysitters/fetchEvaluations",
  async (id, { rejectWithValue }) => {
    try {
      const response = await NannyService.getEvaluations(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.data.message|| "Erreur");
    }
  }
);


export const fetchApplications = createAsyncThunk(
  "babysitters/fetchApplications",
  async (id, { rejectWithValue }) => {
    try {
      const response = await NannyService.getApplications(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data|| "Erreur");
    }
  }
);
export const toggleStatusNanny = createAsyncThunk(
  "babysitters/toggleStatusNanny",
  async ({id, data}, { rejectWithValue }) => {
    
    try {
      const response = await NannyService.toggleStatus(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.data.message|| "Erreur");
    }
  }
);

export const toggleStatusApplication = createAsyncThunk(
  "babysitters/toggleStatusApplication",
  async ({id, data}, { rejectWithValue }) => {
    
    try {
      const response = await NannyService.toggleApplicationStatus(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.data.message || "Erreur");
    }
  }
);
export const deleteApplication = createAsyncThunk("babysitters/deleteApplication", async (AppId, {rejectWithValue}) => {
  try {
    await NannyService.deleteApplication(AppId);
    return AppId;
  } catch (error) {
     return rejectWithValue(error.response.data.data.message || "Erreur");
  }
});

//Define the initial state
const initialState = {
  babysitters: [],
  babysitter:{},
      evaluations: [],
    applications: [],
    report:{},
  message: "",
  showMessage: false,
  loading: false,
  error: false,
};

const nannySlice = createSlice({
  name: "nannies",
  initialState,
  reducers: {
    showMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },

    showLoading: (state) => {
      state.loading = true;
    },
    AddedInSuccess: (state, action) => {
      state.loading = false;
    },
    hideError: (state, action) => {
     
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBabysitters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBabysitters.fulfilled, (state, action) => {
        state.loading = false;
        state.babysitters = action.payload;
        state.error = null;
      })
      .addCase(fetchBabysitters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.showMessage = true;
      })
      .addCase(fetchOneBabysitter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOneBabysitter.fulfilled, (state, action) => {
        state.loading = false;
        state.babysitter = action.payload;
        state.error = null;
      })
      .addCase(fetchOneBabysitter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.showMessage = true;
      })
      // .addCase(fetchNannyReport.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(fetchNannyReport.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.report = action.payload;
      //   state.error = null;
      // })
      // .addCase(fetchNannyReport.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      //   state.showMessage = true;
      // })
      .addCase(addBabysitter.fulfilled, (state, action) => {
        state.loading = false;
        state.babysitters.push(action.payload);
        state.error = null;
      })
      .addCase(addBabysitter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(addBabysitter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;

        state.showMessage = true;
      })
      .addCase(updateBabysitter.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBabysitter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateBabysitter.fulfilled, (state, action) => {
        const index = state.babysitters.findIndex(
          (babysitter) => babysitter.id === action.payload.id
        );
        state.babysitters[index] = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteBabysitter.fulfilled, (state, action) => {
        const nannyId = action.payload;
        state.babysitters = state.babysitters.filter(
          (nanny) => nanny.id !== nannyId
        );
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchEvaluations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvaluations.fulfilled, (state, action) => {
        state.loading = false;
        state.evaluations = action.payload;
        state.error = null;
      })
      .addCase(fetchEvaluations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchApplications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.applications = action.payload;
        state.error = null;
      })
      .addCase(fetchApplications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toggleStatusNanny.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleStatusNanny.fulfilled, (state, action) => {
        const index = state.babysitters.findIndex(
          (babysitter) => babysitter.id === action.payload.id
        );
        state.babysitters[index] = action.payload;
        state.loading = false;
        state.error = null;
        // window.location.reload();
      })
      .addCase(toggleStatusNanny.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toggleStatusApplication.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleStatusApplication.fulfilled, (state, action) => {
        const index = state.applications.findIndex(
          (application) => application.id === action.payload.id
        );
        state.applications[index] = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(toggleStatusApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteApplication.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteApplication.fulfilled, (state, action) => {
        const jobId = action.payload;
        state.jobs = state.jobs.filter((job) => job.id !== jobId);
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
      
});


export default nannySlice.reducer;

export const { showLoading, showMessage, hideMessage, hideError, AddedInSuccess } = nannySlice.actions;
